import firebase from 'firebase/app';
import 'firebase/firestore';

export const AddOrg = async (company, result, token) => {

    await firebase
        .firestore()
        .collection('organizations')
        .doc(company)
        .collection('users')
        .doc(result.additionalUserInfo.profile.name)
        .get()
        .then( async (doc)=>{
            if(!doc.exists){
                await firebase
                .firestore()
                .collection("organizations")
                .doc(company)
                .collection("users")
                .where("role", "==", 'admin')
                .get()
                .then((querySnapshot) => {
                        if(querySnapshot.docs.length > 0){
                            //console.log("Document exists");
                            userMembership(company, result, token)
                        }else{
                            //console.log("No such document!");
                            userAdmin(company, result, token)
                            teamToken(company, result)
                        }
                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                });
            }else{
                //console.log('doc.exists');
            }
        })
        .then(()=>{
            signedOrg(company)
            // SaveSearchLastFive(company, result)
        })
    
}

const userMembership = (company, result, token) => {
    firebase
        .firestore()
        .collection('organizations')
        .doc(company)
        .collection('users')
        .doc(result.user.displayName)
        .set({
            firstName: result.additionalUserInfo.profile.given_name,
            lastName: result.additionalUserInfo.profile.family_name,
            company: company,
            email: result.additionalUserInfo.profile.email,
            token: token,
            role: 'member'
        })
}

const userAdmin = (company, result, token) => {
    firebase
        .firestore()
        .collection('organizations')
        .doc(company)
        .collection('users')
        .doc(result.user.displayName)
        .set({
            firstName: result.additionalUserInfo.profile.given_name,
            lastName: result.additionalUserInfo.profile.family_name,
            company: company,
            email: result.additionalUserInfo.profile.email,
            token: token,
            role: 'admin',
            master: 'Yoda'
        })
}

const signedOrg = async (company) => {
    await firebase
        .firestore()
        .collection('allSignedOrg')
        .doc(company)
        .get()
        .then((doc) => {
            if (!doc.exists) {
                firebase
                .firestore()
                .collection('allSignedOrg')
                .doc(company)
                .set({
                    company: company
                })
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
}

const teamToken = (company, result) => {
    firebase
        .firestore()
        .collection('organizations')
        .doc(company)
        .collection('teamToken')
        .doc(company)
        .set({
            firstName: result.additionalUserInfo.profile.given_name,
            lastName: result.additionalUserInfo.profile.family_name,
            company: company,
            email: result.additionalUserInfo.profile.email,
            adminId: result.user.uid,
            teamToken: false,
            
        })
}

// const SaveSearchLastFive = (company, result) => {
//     var newDoc =firebase
//                 .firestore()
//                 .collection('organizations')
//                 .doc(company)
//                 .collection('searchedContactLastFive')
//                 .doc(result.user.uid)
//                 .collection('searchedContact')
//                 .doc()

//         newDoc.set({
//                 contactImg: '',
//                 contactFirstName: 'Elon',
//                 contactLastName: 'Musk',     
//                 contactName: 'Elon Musk',
//                 contactCompany: 'Tesla',
//                 contactRole: 'CEO',
//                 contactEducation: 'MIT',
//                 contactFieldOfStudy: 'Electric cars, Rockets',
//                 contactHeadline: 'I change the world with Rockets, Cars, and Doge',
//                 contactCity: 'Austin',
//                 contactLinkdinUrl: '',
//                 contactInterest: ['Rockets', 'Space', 'Cars'],
//                 contactContent: '',
//                 contactArticles: '',
//                 message: '',
//                 createdBy: result.additionalUserInfo.profile.email,
//                 authorID: result.user.uid,
//                 authorFirstName: result.additionalUserInfo.profile.given_name,
//                 authorLastName: result.additionalUserInfo.profile.family_name,
//                 authorCompany: company,
//                 createdAt: new Date(),
//                 docId: newDoc.id
//             })
// }